<template>
    <div class="row mt-10">
        <div class="col-12 col-md-9 col-lg-9 mb-5">
            <div class="card p-5">
                <Calendar id="calendarRdvId" :headerToolbar="false" :event="events" @handleClick="handleClick" @handleMonthClick="handleMonthClick"/>
            </div>
        </div>
        <div class="bg-white col-12 col-md-3 col-lg-3">
            <div class="card p-5 shadow-sm mb-5">
                <Calendar id="calendarRdvMonthId" :availableViews="month" :size="size"/>
            </div>
            <div class="mb-5">
                <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" id="flexCheckChecked"
                        v-model="filter.rdv_created"
                        checked="checked" />
                    <label class="form-check-label" for="flexCheckChecked">{{ $t('appointments.my_appointments') }}</label>
                </div>
            </div>
            <div class="mb-5">
                <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" id="flexCheckChecked"
                        v-model="filter.rdv_guested"
                        checked="checked" />
                    <label class="form-check-label" for="flexCheckChecked">{{ $t('appointments.invite_appointments') }}</label>
                </div>
            </div>
            <div class="card shadow-sm px-5 py-10">
                <h2 class="text-center mb-5">{{ $t('appointments.legend') }}</h2>
                <div class="d-flex flex-wrap align-items-center mb-5">
                    <div class="d-flex align-items-center me-4 mb-5" v-for="(statusVal, index) in status" :key="index">
                        <div :class="'bg-light-'+statusVal.color" style="width: 80px; height: 15px;"></div>
                        <span class="ms-2" :class="'text-'+statusVal.color">{{statusVal[locale]}}</span>
                    </div>
                </div>
                <div class="d-flex">
                    <i class="text-warning fs-3 mt-2 fas fa-envelope"></i>
                    <i class="text-warning me-3 fas fa-plus"></i>
                    <span class="fs-3">{{ $t('appointments.invite_appointments') }}</span>
                </div>
            </div>
<!--            <div class="mt-5">
                <button class="btn btn-primary w-100" @click="openSyncModal">
                    {{ $t('appointments.sync_calendar') }}
                </button>
            </div>-->

        </div>

<!--      <SyncModal
          id="syncModal"
          :sync-status="syncStatus"
          @init-sync="initSync"
          @disconnect-service="disconnectService"
          @manual-sync="manualSyncAll"
          @hide-modal="onHideModal"
      />-->
    </div>   
</template>

<script setup>
    import Calendar from "@/components/Calendar.vue"
    import {ref, onMounted, defineProps, nextTick, watch, computed} from "vue";
    import {useRouter} from "vue-router";
    import {useStore} from "vuex";
    import {useLocales} from "@/composables/locales";

    const {locale} = useLocales()
    const store = useStore()
    const router = useRouter()


    const props = defineProps({
        filter: {
            type: Object,
            default: () => ({
                status: 'all',
                type: 'all',
                start_date: '',
                end_date: '',
                search: '',
                rdv_created: true,
                rdv_guested: true
            })
        }
    })

    const month = ref(['dayGridMonth'])
    const size = ref({
        contentHeight: 150,
        height: 250
    })
    const isLoading = ref(false)
    const query = ref(props.filter)

    const events = ref([]);

    const status = computed(() => store.getters['appointments/appointmentStatus'])

    watch(() => props.filter.search, (newValue) => {
        loadCalendarData()
    })

    watch(() => props.filter.status, (newValue) => {
        loadCalendarData()
    })

    watch(() => props.filter.type, (newValue) => {
        loadCalendarData()
    })

    watch(() => props.filter.rdv_created, (newValue) => {
        loadCalendarData()
    })

    watch(() => props.filter.rdv_guested, (newValue) => {
        loadCalendarData()
    })

    watch(() => [query.value.start_date, query.value.end_date], (newValue) => {
        loadCalendarData()
    })

    function loadCalendarData() {
        try {
            isLoading.value = true

            if(query.value.start_date && query.value.end_date){
                store.dispatch('appointments/loadCalendarAppointments', query.value).then((res) => {
                    let appointments = res.data.appointments
                    events.value = []
                    appointments?.filter((item) => {
                        events.value.push({
                            title: item?.title,
                            start: formatCalendarDate(item?.start_time),
                            extendedProps: {
                                id: item?.id,
                                numberMembers:  item?.participants_count,
                                startTime: item?.start_time.split(' ')[1],
                                endTime: item?.end_time.split(' ')[1],
                                check: false,
                                creator: item?.creator_id,
                                color: getStatusColor(item?.status)
                            }
                        })
                    })
                    isLoading.value = false
                })
            }
        }catch (e) {
            isLoading.value = false
        }
    }

    onMounted(() => {
        nextTick(() => {
            loadCalendarData()
          checkOAuthCallback()
        })
    })

    function formatCalendarDate(start){
        let newDateTime = moment(start, "DD-MM-YYYY HH:mm");
        return newDateTime.format("YYYY-MM-DDTHH:mm");
    }

    function getStatusColor(val){
        let color = status.value.filter(el => el.value === val)[0]?.color
        let colorValue = '#0072CE0D'
        if(color){
            switch (color) {
                case 'success':
                colorValue = '#2DA3330D';
                break;
                case 'warning':
                colorValue = '#F078170D';
                break;
                case 'danger':
                colorValue = '#E513350D';
                break;
                default:
                colorValue = '#0072CE0D';
            }
        }
        return colorValue
    }

    function handleClick(id){
        router.push({ name: 'appointments-view', params: { id: id } })
    }

    function handleMonthClick(start, end){
        query.value.start_date = start
        query.value.end_date = end
    }







</script>
